import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => {
  return {
    root: {
      "&:hover": {
        backgroundColor: "transparent"
      }
    },
    checkbox: {
      borderRadius: 3,
      width: 20,
      height: 20,
      backgroundColor: "#ffffff",
      border: "1px solid #335647"
    },
    checkedCheckbox: {
      backgroundColor: "#c0e8d8",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:before": {
        display: "block",
        width: 20,
        height: 20,
        color: "#335647"
      }
    },
    icon: {
      fontSize: 17,
      color: "#335647"
    }
  };
});
